import { Routes, Route } from 'react-router-dom'
import { HomePage } from '../pages/HomePage'
import { LoginPage } from '../pages/LoginPage'
import { RegisterPage } from '../pages/RegisterPage'
import { ForgotPasswordPage } from '../pages/ForgotPasswordPage'
import { ResetPasswordPage } from '../pages/ResetPasswordPage'
import { DashboardPage } from '../pages/DashboardPage'
import { ProfilePage } from '../pages/ProfilePage'
import { SettingsPage } from '../pages/SettingsPage'
import { SubscriptionPage } from '../pages/SubscriptionPage'
import { SubscriptionPlansPage } from '../pages/SubscriptionPlansPage'
import { WordsPage } from '../pages/WordsPage'
import { WordViewPage } from '../pages/WordViewPage'
import { DictionariesPage } from '../pages/DictionariesPage'
import { DictionaryDetailsPage } from '../pages/DictionaryDetailsPage'
import { TagsPage } from '../pages/TagsPage'
import { GroupsPage } from '../pages/GroupsPage'
import { GroupDetailsPage } from '../pages/GroupDetailsPage'
import { UsersPage } from '../pages/UsersPage'
import { UserDetailsPage } from '../pages/UserDetailsPage'
import { PlacementRunsPage } from '../pages/PlacementRunsPage'
import { PlacementRunDetailPage } from '../pages/PlacementRunDetailPage'
import { UserSettingsPage } from '../pages/UserSettingsPage'
import { UserActivityPage } from '../pages/UserActivityPage'
import { ProfileActivityPage } from '../pages/ProfileActivityPage'
import { AdminUserActivityPage } from '../pages/admin/AdminUserActivityPage'
import { TeacherViewPage } from '../pages/TeacherViewPage'
import { AdminUsersPage } from '../pages/admin/AdminUsersPage'
import { AdminUserViewPage } from '../pages/admin/AdminUserViewPage'
import { AdminPaymentsPage } from '../pages/admin/AdminPaymentsPage'
import { AdminFinancePage } from '../pages/admin/AdminFinancePage'
import { AdminTopupRequestsPage } from '../pages/admin/AdminTopupRequestsPage'
import { AdminSubscriptionsPage } from '../pages/admin/AdminSubscriptionsPage'
import { AdminSubscriptionPlansPage } from '../pages/admin/AdminSubscriptionPlansPage'
import { AdminNewsPage } from '../pages/admin/AdminNewsPage'
import { AdminChatStickersPage } from '../pages/admin/AdminChatStickersPage'
import { AdminProgramsPage } from '../pages/admin/AdminProgramsPage'
import { AdminPlacementBankPage } from '../pages/admin/AdminPlacementBankPage'
import { PlacementTestPage } from '../pages/PlacementTestPage'
import { AdminChatStickerPackPage } from '../pages/admin/AdminChatStickerPackPage'
import { NewsPage } from '../pages/NewsPage'
import { NotFoundPage } from '../pages/NotFoundPage'
import { CardsPage } from '../pages/CardsPage'
import { CardViewPage } from '../pages/CardViewPage'
import { LessonsIndexPage } from '../pages/LessonsIndexPage'
import { LessonDetailsPage } from '../pages/LessonDetailsPage'
import { StudentSchedulePage } from '../pages/StudentSchedulePage'
import { HomeworksPage } from '../pages/HomeworksPage'
import { UserHomeworksPage } from '../pages/UserHomeworksPage'
import { HomeworkItemCheckPage } from '../pages/HomeworkItemCheckPage'
import { TestsPage } from '../pages/TestsPage'
import { UserTestsPage } from '../pages/UserTestsPage'
import { UserProgramsPage } from '../pages/UserProgramsPage'
import { SelfTestCreatePage } from '../pages/SelfTestCreatePage'
import { LessonDictionaryFillCreatePage } from '../pages/LessonDictionaryFillCreatePage'
import { DictionaryFillRunPage } from '../pages/DictionaryFillRunPage'
import { LessonTestCreatePage } from '../pages/LessonTestCreatePage'
import { TestPage } from '../pages/TestPage'
import { ChatPage } from '../pages/ChatPage'
import { TeacherBillingPage } from '../pages/TeacherBillingPage'
import { TeacherBalancePage } from '../pages/TeacherBalancePage'
import { AccountingPage } from '../pages/AccountingPage'
import { VacationsPage } from '../pages/VacationsPage'
import { HelpPage } from '../pages/HelpPage'
import { TtsTasksPage } from '../pages/TtsTasksPage'
import { StudentFinancePage } from '../pages/StudentFinancePage'
import { UserFinancePage } from '../pages/UserFinancePage'
import { NotificationsPage } from '../pages/NotificationsPage'
import { NotificationPreferencesPage } from '../pages/NotificationPreferencesPage'
import { ProfileSecurityPage } from '../pages/ProfileSecurityPage'
import { ProfileConnectionsPage } from '../pages/ProfileConnectionsPage'
import { OAuthAuthorizePage } from '../pages/OAuthAuthorizePage'
import { StudentFormFieldsPage } from '../pages/StudentFormFieldsPage'
import { AdminStudentFormFieldsPage } from '../pages/admin/AdminStudentFormFieldsPage'
import { ProtectedRoute } from '../components/common/ProtectedRoute'
import { TeacherRoute } from '../components/common/TeacherRoute'
import { StudentRoute } from '../components/common/StudentRoute'
import { ProgramsPage } from '../pages/ProgramsPage'
import { ProgramEditorPage } from '../pages/ProgramEditorPage'
import { ExerciseRunPage } from '../pages/ExerciseRunPage'
import { ExerciseReviewQueuePage } from '../pages/ExerciseReviewQueuePage'
import { ExerciseCheckPage } from '../pages/ExerciseCheckPage'
import { ExerciseBankPage } from '../pages/ExerciseBankPage'
import { ProgramAssignmentPage } from '../pages/ProgramAssignmentPage'
import { MyProgramsPage } from '../pages/MyProgramsPage'
import { MyProgramPage } from '../pages/MyProgramPage'
import { AdminRoute } from '../components/common/AdminRoute'

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      {/* Список и deep-link на новость: один компонент, модалка поверх списка */}
      <Route path="/news" element={<NewsPage />} />
      <Route path="/news/:slug" element={<NewsPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/notifications"
        element={
          <ProtectedRoute>
            <NotificationsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile/activity"
        element={
          <ProtectedRoute>
            <ProfileActivityPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile/notifications"
        element={
          <ProtectedRoute>
            <NotificationPreferencesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile/security"
        element={
          <ProtectedRoute>
            <ProfileSecurityPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile/connections"
        element={
          <ProtectedRoute>
            <ProfileConnectionsPage />
          </ProtectedRoute>
        }
      />
      {/*
        Экран согласия на подключение AI-агента. Не под ProtectedRoute: сюда
        приходят по редиректу с API с параметрами OAuth в query, и стандартный
        редирект на логин потерял бы их — страница сама сохраняет адрес возврата.
      */}
      <Route path="/oauth/authorize" element={<OAuthAuthorizePage />} />
      <Route
        path="/profile/student-form-fields"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <StudentFormFieldsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile/settings"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <SettingsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile/subscription"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <SubscriptionPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile/subscription/change"
        element={
          <ProtectedRoute>
            <SubscriptionPlansPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile/billing"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <TeacherBillingPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile/balance"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <TeacherBalancePage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/finance"
        element={
          <ProtectedRoute>
            <StudentRoute>
              <StudentFinancePage />
            </StudentRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/accounting"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <AccountingPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/vacations"
        element={
          <ProtectedRoute>
            <VacationsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/help"
        element={
          <ProtectedRoute>
            <HelpPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/words"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <WordsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tts-tasks"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <TtsTasksPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/words/:id"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <WordViewPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dictionaries"
        element={
          <ProtectedRoute>
            <DictionariesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dictionaries/:id"
        element={
          <ProtectedRoute>
            <DictionaryDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tags"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <TagsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/groups"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <GroupsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/groups/:id"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <GroupDetailsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <UsersPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id/finance"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <UserFinancePage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id/activity"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <UserActivityPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id/settings"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <UserSettingsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <UserDetailsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id/language-profile"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <PlacementRunsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id/language-profile/runs/:runId"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <PlacementRunDetailPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/teacher"
        element={
          <ProtectedRoute>
            <StudentRoute>
              <TeacherViewPage />
            </StudentRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminUsersPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/users/:id"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminUserViewPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/users/:id/activity"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminUserActivityPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/payments"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminPaymentsPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/finance"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminFinancePage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/topup-requests"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminTopupRequestsPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/subscriptions"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminSubscriptionsPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/subscription-plans"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminSubscriptionPlansPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/news"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminNewsPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/programs"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminProgramsPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/placement"
        element={
          <ProtectedRoute>
            <PlacementTestPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/placement-bank"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminPlacementBankPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/student-form-fields"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminStudentFormFieldsPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/chat-stickers"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminChatStickersPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/chat-stickers/:packId"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminChatStickerPackPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/programs"
        element={
          <ProtectedRoute>
            <TeacherRoute allowAdmin>
              <ProgramsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/programs/:id"
        element={
          <ProtectedRoute>
            <TeacherRoute allowAdmin>
              <ProgramEditorPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/program-assignments/:id"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <ProgramAssignmentPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/my/programs"
        element={
          <ProtectedRoute>
            <StudentRoute>
              <MyProgramsPage />
            </StudentRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/my/programs/:id"
        element={
          <ProtectedRoute>
            <StudentRoute>
              <MyProgramPage />
            </StudentRoute>
          </ProtectedRoute>
        }
      />
      {/* Решение задания доступно и ученику, и учителю: учитель открывает ту же
          страницу, чтобы посмотреть работу глазами ученика */}
      <Route
        path="/exercise-runs/:id"
        element={
          <ProtectedRoute>
            <ExerciseRunPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/exercises/review"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <ExerciseReviewQueuePage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/exercises/review/:id"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <ExerciseCheckPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/exercises"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <ExerciseBankPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/lessons"
        element={
          <ProtectedRoute>
            <LessonsIndexPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/lessons/:id"
        element={
          <ProtectedRoute>
            <LessonDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tests"
        element={
          <ProtectedRoute>
            <StudentRoute>
              <TestsPage />
            </StudentRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id/tests"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <UserTestsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id/programs"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <UserProgramsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      {/* Карточка назначения в контексте ученика: из его раздела программ
          учитель не должен вылетать в общий /program-assignments */}
      <Route
        path="/users/:id/programs/:assignmentId"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <ProgramAssignmentPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tests/self/create"
        element={
          <ProtectedRoute>
            <StudentRoute>
              <SelfTestCreatePage />
            </StudentRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/lessons/:lessonId/tests/create"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <LessonTestCreatePage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/lessons/:lessonId/dictionary-fill/create"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <LessonDictionaryFillCreatePage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dictionary-fill/:runId"
        element={
          <ProtectedRoute>
            <DictionaryFillRunPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tests/:testId"
        element={
          <ProtectedRoute>
            <TestPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/schedule"
        element={
          <ProtectedRoute>
            <StudentRoute>
              <StudentSchedulePage />
            </StudentRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/homeworks"
        element={
          <ProtectedRoute>
            <HomeworksPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id/homeworks"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <UserHomeworksPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:userId/homeworks/:homeworkId/items/:itemId/check"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <HomeworkItemCheckPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id/cards"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <CardsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id/cards/:cardId"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <CardViewPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/cards"
        element={
          <ProtectedRoute>
            <StudentRoute>
              <CardsPage />
            </StudentRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/cards/:id"
        element={
          <ProtectedRoute>
            <StudentRoute>
              <CardViewPage />
            </StudentRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/chat"
        element={
          <ProtectedRoute>
            <ChatPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/chat/rooms/:roomId"
        element={
          <ProtectedRoute>
            <ChatPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/chat/direct/:userId"
        element={
          <ProtectedRoute>
            <ChatPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/chat/group/:groupId"
        element={
          <ProtectedRoute>
            <ChatPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
